export default function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-hierarchy/src/hierarchy/descendants.js
// module id = b4YN
// module chunks = 0